import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBybitEarn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M18.5 2.75a.75.75 0 0 1 .75.75v1.75H21a.75.75 0 0 1 0 1.5h-1.75V8.5a.75.75 0 0 1-1.5 0V6.75H16a.75.75 0 0 1 0-1.5h1.75V3.5a.75.75 0 0 1 .75-.75ZM15.602 9.8V8H8.165v1.8h2.742v1.176C8.678 11.076 7 11.51 7 12.033c0 .522 1.678.958 3.907 1.057v3.774h1.953v-3.775c2.22-.1 3.89-.536 3.89-1.056 0-.521-1.67-.956-3.89-1.056V9.8h2.742Zm.308 2.127c0 .343-1.297.631-3.05.711l-.113.005h-.012l-.107.004h-.011l-.24.007h-.005l-.109.002h-.03l-.086.001h-.543l-.085-.001h-.029l-.101-.002h-.011a23.22 23.22 0 0 1-.355-.011h-.002l-.116-.005c-1.761-.079-3.067-.368-3.067-.713s1.306-.634 3.067-.713v1.091a18.834 18.834 0 0 0 1.954 0v-1.088c1.754.08 3.051.368 3.051.712Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 12a8.25 8.25 0 0 1 9.752-8.114.75.75 0 0 0 .271-1.475A9.801 9.801 0 0 0 12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75c0-.503-.038-.997-.112-1.48a.75.75 0 1 0-1.483.226A8.25 8.25 0 1 1 3.75 12Z"
    />
  </svg>
);
export default SvgTwoColorBybitEarn;
